import {useEffect} from 'react'
import {usePageProps} from 'context/pageProps'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

import type {PageProps as SearchPageProps} from 'pages/Hotel/Search'

export const useTrackServerSearch = () => {
  const toggle = useToggle()
  const {isEligibleForServerSearchExperiment} =
    usePageProps() as SearchPageProps
  useEffect(() => {
    if (isEligibleForServerSearchExperiment)
      toggle('d694612d-ssr-srp-anchor-preheat--v1')
  }, [isEligibleForServerSearchExperiment, toggle])
}
